import { WorkflowArea } from '../../../../aumico-lib-cpmm-fe/src/lib/enums/workflow-area.enum';
import { IssueDetailTableValue } from './issue-detail-table-value.interface';

export interface WorkflowDataTableValue {
    area: WorkflowArea;
    summary: string;
    totalIssueCount: number;
    completedIssueCount: number;
    issuesDetails: IssueDetailTableValue[];
}
